export const products = [
  {
    id: 'pp-001',
    name: 'Neon Bloom MagSafe',
    price: 48,
    device: 'iPhone 15 Pro',
    image: 'https://images.unsplash.com/photo-1618366712010-f4ae9c647dcb?w=1000&q=80',
    tag: 'ULTRA LIMITED',
    description: 'Military-grade drop protection with reactive neon pigments.',
    specs: ['MagSafe Compatible', 'Aramid Fiber', 'Anti-Yellowing']
  },
  {
    id: 'pp-002',
    name: 'Circuit Rose Clear',
    price: 42,
    device: 'S24 Ultra',
    image: 'https://images.unsplash.com/photo-1550684848-fac1c5b4e853?w=1000&q=80',
    tag: 'NEW DROP',
    description: 'Revealing the internal beauty of your tech through floral circuitry.',
    specs: ['Slim Profile', 'Scratch Resistant', 'Precision Cutouts']
  },
  {
    id: 'pp-003',
    name: 'Glitch Petal Tough',
    price: 58,
    device: 'Pixel 8 Pro',
    image: 'https://images.unsplash.com/photo-1528459801416-a9e53bbf4e17?w=1000&q=80',
    tag: 'BEST SELLER',
    description: 'Triple-layer armor for the digital adventurer.',
    specs: ['12ft Drop Protection', 'Eco-Friendly', 'Matte Finish']
  },
  {
    id: 'pp-004',
    name: 'Holo Leaf Grip',
    price: 28,
    device: 'Universal',
    image: 'https://images.unsplash.com/photo-1558591710-4b4a1ae0f04d?w=1000&q=80',
    description: 'Iridescent structural support for one-handed scrolling.',
    specs: ['360° Rotation', 'Strong Adhesive', 'Ultra-Thin']
  },
  {
    id: 'pp-005',
    name: 'Cyber Vine Lanyard',
    price: 35,
    device: 'Universal',
    image: 'https://images.unsplash.com/photo-1550684376-efcbd6e3f031?w=1000&q=80',
    tag: 'LOW STOCK',
    description: 'Paracord-inspired lanyard with quick-release hardware.',
    specs: ['Adjustable Length', 'Steel Carabiner', 'Reflective Thread']
  },
  {
    id: 'pp-006',
    name: 'Synthwave Flora',
    price: 48,
    device: 'iPhone 15 Pro',
    image: 'https://images.unsplash.com/photo-1614850523459-c2f4c699c52e?w=1000&q=80',
    description: 'Retro-future aesthetics meet modern hardware protection.',
    specs: ['Dual-Layer', 'Raised Bezels', 'Soft-Touch']
  }
];

export const reviews = [
  { id: 1, user: '@tech_bloom', text: "The drop was seamless. The Neon Bloom case feels like a piece of art that actually protects my phone. The MagSafe magnets are incredibly strong.", rating: 5 },
  { id: 2, user: '@cyber_nomad', text: "Finally, a brand that understands the aesthetic. The Creator Kit is a must-have for anyone filming on the go. High-quality materials only.", rating: 5 },
  { id: 3, user: '@mxs_design', text: "The attention to detail in the packaging and the product itself is unmatched. PixelPetals is the future of accessories.", rating: 5 },
];

export const faqs = [
  { q: "What is a 'Drop' system?", a: "We release limited edition collections in small batches. Once a drop sells out, those specific designs are vaulted and never restocked to maintain exclusivity." },
  { q: "Global shipping availability?", a: "We ship to over 50 countries. All Drop 001 orders include priority tracking and sustainable packaging." },
  { q: "Warranty and protection?", a: "Every case comes with a 12-month 'Hardware Shield' warranty covering any manufacturing defects or unexpected wear." },
];